import { OptionDefinition } from "../../Commons/Options/CommandBasedOptionsParser";

export const debugOnlyOptionDefinition: OptionDefinition<BuildDebugOnlyOption> = {
    alias: "d",
    name: "debug-only",
    defaultValue: { buildDebugOnly: false },
    parse: (input: boolean) => ({ buildDebugOnly: input }),
    doesNotRequireValue: true,
    description:
        "Собирать только debug-сборки движка и форм. " +
        "ВНИМАНИЕ: при работе в браузере необходимо использовать параметр ?debug=true",
};

export interface BuildDebugOnlyOption {
    buildDebugOnly: boolean;
}
